// extracted by mini-css-extract-plugin
module.exports = {"text1Line":"styles_text1Line__51_5K","ellipsis":"styles_ellipsis__TIoSn","text2AndMoreLines":"styles_text2AndMoreLines__dzBH_","tooltipTrigger":"styles_tooltipTrigger__hztMY"};